import $ from 'jquery';
import lodash from 'lodash';

import { geoAddressSearch } from '../queries';

const renderItem = (value, isFiller = false) => {
    const className = isFiller ? 'ui-input-list__item' : 'ui-input-list__item js-ui-input-list__item';

    return (`
        <div class="${className}" data-value="${value}">${value}</div>
    `);
};

const getItems = lodash.debounce(async function ($component) {
    const value = $component.find('.ui-input-list__control').val();
    const $items = $component.find('.ui-input-list__items');
    if (!value) {
        return;
    }
    $items.html(renderItem('Поиск...', true));
    const response = await geoAddressSearch(value);
    if (!response.isSuccess || response.items.length === 0) {
        $items.html(renderItem('Адрес ещё не определён, продолжайте ввод', true));
    } else {
        $items.html(response.items.map(item => renderItem(item)));
    }
}, 300);

const selectList = function () {
    const $component = $(this).parents('.ui-input');
    const $list = $component.find('.ui-input-list');

    $list.show();
    $component.find('.ui-input-list .ui-input-list__control').focus();
};

$('.ui-input--address .ui-input__control')
    .focus(selectList)
    .click(selectList)
    .keydown(() => false)
    .keypress(() => false);

$('.ui-input-list__control').blur(function () {
    setTimeout(() => {
        $(this).parents('.ui-input-list').hide();
    }, 200);
});

$('.ui-input-list__control').keyup(function () {
    getItems($(this).parents('.ui-input-list'));
});


$(document).on('click', '.js-ui-input-list__item', function () {
    const $control = $(this).parents('.ui-input').find('.ui-input__control')
    const value = $(this).attr('data-value').trim();
    $control.attr('data-value', value).val(value);
});
